import { getTokens } from "../systemUtils/systemUtils";

export const getUserRole = () => {
  const { accessToken } = getTokens();
  if (accessToken) {
    const tokenPayload = atob(accessToken.split(".")[1]);
    const tokenDetails = JSON.parse(tokenPayload);
    return Array.isArray(tokenDetails.role) ? tokenDetails.role : [tokenDetails.role];
  }
  return undefined;
};
